import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: services-badge;

  cursor: pointer;
  color: ${theme.colors.p600};
`

const contentStyles = ({ theme }) => css`
  label: services-badge__content;

  max-width: 180px;
`

export const ServicesBadge = styled('div')(baseStyles)
export const Content = styled('div')(contentStyles)
